import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import InfoIcon from '@mui/icons-material/Info';

// Images
import heroImage from '../assets/images/group-438-1.png';

const HeroSection = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #8ca6b8 0%, #a0b4c4 50%, #b8c8d4 100%)',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  position: 'relative',
  overflow: 'hidden',
}));





const HavenIaqStartPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <HeroSection>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            {/* Left Content */}
            <Grid item xs={12} md={6}>
              <Box sx={{ color: 'white', pr: { md: 4 } }}>
                <Typography variant="h2" component="h1" sx={{ 
                  fontWeight: 'bold', 
                  mb: 3,
                  fontSize: { xs: '2.5rem', md: '4rem' },
                  color: 'white',
                  lineHeight: 1.1
                }}>
                  Let's get started.
                </Typography>
                
                <Typography variant="h5" sx={{ 
                  mb: 4,
                  fontSize: { xs: '1.3rem', md: '1.5rem' },
                  color: 'white',
                  fontWeight: 'normal'
                }}>
                  How can we best direct you?
                </Typography>

                {/* Buttons */}
                <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => window.open('/become-a-pro', '_blank')}
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: 'white',
                      fontWeight: 'bold',
                      px: 4,
                      py: 1.5,
                      fontSize: '1rem',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                  >
                    I'M AN HVAC PRO
                  </Button>
                  
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => window.open('/homeowner-start', '_blank')}
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: 'white',
                      fontWeight: 'bold',
                      px: 4,
                      py: 1.5,
                      fontSize: '1rem',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                  >
                    I'M A HOMEOWNER
                  </Button>
                </Box>

                {/* Info Text */}
                <Box sx={{ mt: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <InfoIcon sx={{ 
                      color: 'white', 
                      mr: 2, 
                      mt: 0.5,
                      fontSize: '1.2rem'
                    }} />
                    <Typography variant="body1" sx={{ 
                      color: 'white',
                      lineHeight: 1.6,
                      fontSize: '1rem'
                    }}>
                      <strong>HVAC Pro:</strong> A professional in the HVAC field who wants to become a HAVEN Pro.
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <InfoIcon sx={{ 
                      color: 'white', 
                      mr: 2, 
                      mt: 0.5,
                      fontSize: '1.2rem'
                    }} />
                    <Typography variant="body1" sx={{ 
                      color: 'white',
                      lineHeight: 1.6,
                      fontSize: '1rem'
                    }}>
                      <strong>Homeowner:</strong> Someone who wants to have HAVEN installed in their home.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Right Image */}
            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: 'center' }}>
                <img 
                  src={heroImage} 
                  alt="HAVEN Pro with devices" 
                  style={{ 
                    width: '100%', 
                    maxWidth: '600px',
                    height: 'auto'
                  }} 
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </HeroSection>


    </Box>
  );
};

export default HavenIaqStartPage; 